export const APPS_CATALOG = [
  {
    slug: "parasut",
    name: "Paraşüt",
    status: "active",
    category: "Muhasebe",
    description: "Ön muhasebe ve e-fatura süreçlerinizi ObiHub ile entegre yönetin.",
    longDescription:
      "Paraşüt bağlantısı ile sipariş, fatura ve muhasebe süreçlerinizi tek panelden yönetebilirsiniz. Bağlantı sonrası entegrasyon ayarlarınızı tamamlayarak akışı aktif edebilirsiniz.",
  },
  {
    slug: "bizimhesap",
    name: "BizimHesap",
    status: "active",
    category: "Muhasebe",
    description: "BizimHesap ile sipariş ve fatura süreçlerinizi ObiHub üzerinden bağlayın.",
    longDescription:
      "BizimHesap bağlantısı ile WooCommerce, Trendyol ve diğer kanal siparişlerinden doğan fatura akışlarını tek panelden yönetebilirsiniz. ApiKey bilgisi ile bağlantıyı hızlıca aktif edebilir, token üretimini ObiHub tarafına bırakabilirsiniz.",
  },
  {
    slug: "benimpos",
    name: "BenimPOS",
    logo: "/integrations/benimpos.png?v=20261030",
    status: "active",
    category: "Muhasebe",
    description: "BenimPOS ile satış, stok ve cari hareketlerinizi ObiHub üzerinden yönetin.",
    longDescription:
      "BenimPOS entegrasyonu ile WooCommerce ve pazaryeri siparişlerinizi otomatik olarak BenimPOS'a aktarın. Müşteri kartları oluşturulur, satış kaydı açılır ve stok düşümü yapılır. BenimPOS üzerindeki e-Fatura entegrasyonunuz (Mysoft, EDM, eLogo veya E-Dönüştür) aynı anda çalışmaya devam eder. Branch-ID, Api Key ve Secret Key ile dakikalar içinde bağlantı kurabilirsiniz.",
  },
  {
    slug: "turkcell-efatura",
    name: "Turkcell e-Fatura",
    status: "active",
    category: "E-Fatura",
    logo: "/integrations/turkcell-efatura.png",
    description: "Turkcell e-Şirket ile e-Fatura ve e-Arşiv faturalarınızı ObiHub üzerinden gönderin.",
    longDescription:
      "Turkcell e-Şirket entegrasyonu ile siparişlerinizden doğrudan e-Fatura veya e-Arşiv faturası oluşturun ve GİB'e iletin. API Key ile dakikalar içinde bağlantı kurabilir, gönderilen ve gelen faturaları tek panelden yönetebilirsiniz. Test ortamı desteği ile canlıya geçmeden önce entegrasyonunuzu doğrulayabilirsiniz.",
  },
  {
    slug: "trendyol-efaturam",
    name: "Trendyol E-Faturam",
    status: "coming_soon",
    category: "E-Fatura",
    description: "Trendyol e-fatura mükellefleri için yakında.",
  },
  {
    slug: "hepsiburada-efaturam",
    name: "HepsiBurada E-Faturam",
    status: "coming_soon",
    category: "E-Fatura",
    description: "HepsiBurada e-fatura mükellefleri için yakında.",
  },
  {
    slug: "n11-efaturam",
    name: "N11 E-Faturam",
    status: "coming_soon",
    category: "E-Fatura",
    description: "N11 e-fatura mükellefleri için yakında.",
  },
  {
    slug: "elogo",
    name: "E-Logo",
    status: "coming_soon",
    category: "E-Fatura",
    description: "eLogo ile e-fatura/e-arşiv entegrasyonu yakında.",
  },
  {
    slug: "logo-isbasi",
    name: "Logo İş Başı",
    status: "coming_soon",
    category: "Muhasebe",
    description: "Logo İş Başı bağlantısı yakında.",
  },
  {
    slug: "kolaybi",
    name: "KolayBi",
    status: "coming_soon",
    category: "Muhasebe",
    description: "KolayBi entegrasyonu yakında.",
  },
  {
    slug: "mikro",
    name: "Mikro",
    status: "coming_soon",
    category: "Muhasebe",
    description: "Mikro entegrasyonu yakında.",
  },
  {
    slug: "edm",
    name: "EDM",
    status: "coming_soon",
    category: "E-Dönüşüm",
    description: "EDM entegrasyonu yakında.",
  },
  {
    slug: "isnet",
    name: "İşNet",
    status: "coming_soon",
    category: "E-Dönüşüm",
    description: "İşNet entegrasyonu yakında.",
  },
];

export function getAppBySlug(slug) {
  return APPS_CATALOG.find((x) => x.slug === slug) || null;
}
